import {Pipe, PipeTransform} from '@angular/core';
import {StringUtils} from "@ispm/shared/utils/String.utils";

@Pipe({name: 'multiHighlight'})
export class MultiHighlightPipe implements PipeTransform {

  transform(value: any, searchText: any = ''): any {
    try {
      if (!(searchText && value)) {
        return value;
      }
      const searchChunks: string[] = StringUtils.getChunks(searchText);
      let outValue = value.toString().replace(/&lt;/g,'<').replace(/&gt;/g,'>');
      searchChunks.forEach(chunk => {
        const regex = new RegExp('(' + chunk + ')', 'ig');
        outValue = outValue.replace(regex, StringUtils.REPLACE_EXPRESSION);
      });
      outValue = outValue
        .split(StringUtils.OPEN_SEC).join(StringUtils.OPEN_MARK)
        .split(StringUtils.CLOSE_SEC).join(StringUtils.CLOSE_MARK);
      return outValue;

    } catch (e) {
      return value;
    }
  }
}
